import React from 'react';

const ParticipationAgreementModal = ({ show, handleClose, publisherName }) => {
  const dynamicName = publisherName || 'YAYINCI';

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          <div className="modal-header border-0 bg-light p-4">
            <h5 className="modal-title fw-bold text-dark">İDEALONLİNE DİJİTAL KATILIM SÖZLEŞMESİ</h5>
            <button type="button" className="btn-close shadow-none" onClick={handleClose}></button>
          </div>
          <div className="modal-body p-4 pt-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <div className="text-secondary lh-lg" style={{ fontSize: '0.95rem' }}>
              <h4 className="mt-2 text-dark fw-bold" style={{ fontSize: '1.1rem' }}>YAYIN PLATFORMU KATILIM SÖZLEŞMESİ</h4>
              
              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>1. TARAFLAR VE ONAY</h3>
              <p>
                İşbu Sözleşme; bir tarafta İdeal Kültür Yayıncılık Reklam ve Organizasyon San. Tic. Ltd. Şti. (Bundan sonra “İDEAL KÜLTÜR” olarak anılacaktır) ile diğer tarafta, başvuru formundaki bilgileri beyan eden ve bu Sözleşmeyi dijital ortamda onaylayan <strong>{dynamicName}</strong> arasında akdedilmiştir. {dynamicName}, "Okudum, onaylıyorum" kutucuğunu işaretleyerek Sözleşme hükümlerini bütünüyle kabul etmiş sayılır.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>2. SÖZLEŞMENİN KONUSU VE KAPSAMI</h3>
              <p>
                <strong>2.1. Konu:</strong> {dynamicName}’nın telif haklarına sahip olduğunu beyan ettiği matbu veya dijital eserlerin, İDEAL KÜLTÜR tarafından işletilen elektronik veri tabanı platformuna dahil edilmesidir.
              </p>
              <p>
                <strong>2.2. Kullanım Hakkı:</strong> {dynamicName}, eserlerin platformda dijital ortamda yayınlanması amacıyla İDEAL KÜLTÜR’e münhasır olmayan, devredilemez ve alt lisans verilemez bir kullanım hakkı tanır.
              </p>
              <p>
                <strong>2.3. Münhasır Olmama:</strong> İşbu Sözleşme münhasır nitelikte değildir; {dynamicName}, eserlerini başka platformlarda yayınlamakta serbesttir.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>3. MALİ HÜKÜMLER</h3>
              <p>
                İşbu Sözleşme kapsamında {dynamicName}’ya herhangi bir telif, lisans bedeli veya ücret ödenmeyecektir. Eserlerin İDEAL KÜLTÜR platformuna dahil edilme işlemi ücretsizdir. Taraflar, bu iş birliğinden doğan karşılıklı tanıtım ve erişilebilirlik faydasını yeterli kabul ederler.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>4. YAYIN BİLGİLERİ VE KAYIT ESASLARI</h3>
              <p>
                Sisteme dahil edilecek yayınların (Dergi Adı, ISSN, Periyot, Editör Bilgileri vb.) detayları, {dynamicName} tarafından başvuru ekranında doldurulan form verileri esas alınarak belirlenir. Bilgi değişikliklerini bildirmek {dynamicName} sorumluluğundadır.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>5. TARAFLARIN HAK VE YÜKÜMLÜLÜKLERİ</h3>
              <p>
                <strong>5.1. Yayın Taahhüdü:</strong> İDEAL KÜLTÜR, {dynamicName}’ya ait eserleri elektronik veri tabanına eklemeyi ve platform standartları dahilinde erişime sunmayı kabul eder.
              </p>
              <p>
                <strong>5.2. Gizlilik:</strong> İDEAL KÜLTÜR, taraflar arasındaki her türlü ticari ve kurumsal bilgiyi gizli tutmayı; {dynamicName}’nın yazılı onayı olmaksızın üçüncü şahıslara açıklamamayı taahhüt eder.
              </p>
              <p>
                <strong>5.3. İçerikten Çıkarma:</strong> {dynamicName}’nın yayının kaldırılmasını talep etmesi durumunda; güncel sayı girişleri durdurulur, geçmiş sayılar ise sistem işleyişini aksatmayacak şekilde kademeli olarak sistemden çıkarılır. Künye bilgileri indeksleme gereği açık kalmaya devam edebilir.
              </p>
              <p>
                <strong>5.4. Telif ve Sorumluluk:</strong> {dynamicName}, ilettiği yayınların tüm telif haklarına sahip olduğunu beyan eder. Telif haklarıyla ilgili oluşabilecek her türlü hukuki ihtilaf ve zarardan doğrudan {dynamicName} sorumludur.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>6. KİŞİSEL VERİLERİN KORUNMASI (KVKK)</h3>
              <p>
                Taraflar, kişisel verilerin 6698 sayılı KVKK uyarınca işleneceğini kabul eder. İDEAL KÜLTÜR, sözleşme ifası ve bilgilendirme amaçlı olarak {dynamicName} iletişim bilgilerini kullanabilir. {dynamicName}, sisteme yüklediği içeriklerdeki kişisel verilerin hukuka uygun elde edildiğini beyan eder.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>7. TEBLİGAT VE YETKİLİ MAHKEME</h3>
              <p>
                <strong>7.1. Tebligat:</strong> Sistemde beyan edilen e-posta ve fiziki adresler geçerli tebligat adresleridir.
              </p>
              <p>
                <strong>7.2. Yetkili Mahkeme:</strong> Uyuşmazlıkların çözümünde İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri münhasıran yetkilidir.
              </p>

              <h3 className="fw-bold text-dark mt-4 mb-2" style={{ fontSize: '1rem' }}>8. ELEKTRONİK ONAY, DELİL SÖZLEŞMESİ VE YÜRÜRLÜK</h3>
              <p>
                İşbu Sözleşme, {dynamicName}’nın elektronik ortamda “Okudum, onaylıyorum” ibaresini işaretlemesi ile yürürlüğe girer. Taraflar, elektronik ortamda verilen onayın geçerli ve bağlayıcı olduğunu; İDEAL KÜLTÜR’e ait sistem kayıtları, log kayıtları, IP verileri ve elektronik onay verilerinin 6100 sayılı HMK m.193 kapsamında yazılı delil niteliğinde olduğunu kabul ve beyan ederler.
              </p>
            </div>
          </div>
          <div className="modal-footer border-0 p-4 pt-0">
            <button type="button" className="btn btn-primary px-4 rounded-pill fw-medium" onClick={handleClose}>Anladım</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipationAgreementModal;
